import {
  openPhotoSwipe,
  replaceImage
} from './_images';
import {
  qvMobile,
  qvSuperMobile,
  cylMobile,
  cylSuperMobile,
  buildQV,
} from '../modals_2017/_buildQV';
import {
  quickview,
  altImgClick
} from '../modals_2017/_quickview';

const zoomControllerMouseMove = (zoomController) => {
  zoomController.mousemove(function(event) {
    if (event.target.className != 'zoom-close') {
      var that = $(this),
        mainImage = that.children().find('.mainImage'),
        zoomContainer = that.children('#zoomContainer'),
        containerWidth = mainImage.width(),
        containerHeight = mainImage.height(),
        xloc = event.clientX - that.offset().left,
        yloc = event.clientY - (that.offset().top - $(document).scrollTop()),
        xPercentPos = Math.floor((xloc / containerWidth) * 100, 10),
        yPercentPos = Math.floor((yloc / containerHeight) * 100, 10),
        fullWidthCalc = (zoomContainer.width() - that.width()) / that.width(),
        fullHeightCalc = (zoomContainer.height() - that.height()) / that.height(),
        leftMove = (xPercentPos * fullWidthCalc) * (-1),
        topMove = (yPercentPos * fullHeightCalc) * (-1);
      zoomController.addClass('not-zoomed');
      zoomContainer.css({
        left: Math.round(leftMove) + "%",
        top: Math.round(topMove) + "%"
      });
    }
  });
};

const zoomCloseClick = (zoomClose, zoomController) => {
  zoomClose.on('click', function() {
    $(this).parents('.zoomController').trigger('mouseleave');
    return false;
  });
};

const mainImageMouseEnter = (mainImage) => {
  mainImage.on('mouseenter', function() {
    var that = $(this),
      mainImageSrc = (that.length) ? that.attr('src') : undefined,
      zoomImage = that.children().find('#zoomImage');
    zoomImage.attr('src', mainImageSrc.split('/main/').join('/zoom/'));
  });
};

const zoomControllerClick = (zoomController) => {
  zoomController.click(function() {
    var that = $(this),
      zoomClose = that.children('.zoom-close');
    if (zoomClose.is(':hidden')) {
      var children = that.children(),
        mainImage = children.find('.mainImage'),
        mainImageSrc = (mainImage.length) ? mainImage.attr('src') : undefined,
        zoomImage = children.find('#zoomImage');
      zoomImage.attr('src', mainImageSrc.split('/main/').join('/zoom/')); //This is also happening above on hover. It's being set here as a backup.
      mainImage.css('visibility', 'hidden');
      zoomClose.show();
      that.toggleClass('is-zoomed');
      var zoomContainer = that.children('#zoomContainer'),
        containerWidth = mainImage.width(),
        containerHeight = mainImage.height(),
        xloc = event.clientX - that.offset().left,
        yloc = event.clientY - (that.offset().top - $(document).scrollTop()),
        xPercentPos = Math.floor((xloc / containerWidth) * 100, 10),
        yPercentPos = Math.floor((yloc / containerHeight) * 100, 10),
        fullWidthCalc = (zoomContainer.width() - that.width()) / that.width(),
        fullHeightCalc = (zoomContainer.height() - that.height()) / that.height(),
        leftMove = (xPercentPos * fullWidthCalc) * (-1),
        topMove = (yPercentPos * fullHeightCalc) * (-1);
      zoomContainer.css({
        left: Math.round(leftMove) + "%",
        top: Math.round(topMove) + "%"
      });
    } else that.trigger('mouseleave');
  });
};

const zoomControllerMouseLeave = (zoomController) => {
  zoomController.on('mouseleave', function() {
    var that = $(this),
      children = that.children(),
      mainImage = children.find('.mainImage'),
      zoomContainer = that.children('#zoomContainer'),
      zoomClose = that.children('.zoom-close'),
      zoomImage = children.find('#zoomImage');
    mainImage.css('visibility', 'visible');
    zoomClose.hide();
    that.removeClass('is-zoomed');
    zoomImage.attr('src', ''); //Helps prevent a possible flash on slow connections
  });
};

const zoomImageEvents = (zoomController, mainImage, zoomContainer, zoomClose) => {
  zoomControllerMouseMove(zoomController);
  zoomCloseClick(zoomClose, zoomController);
  mainImageMouseEnter(mainImage);
  zoomControllerClick(zoomController);
  zoomControllerMouseLeave(zoomController);
};

const zoomQVImageD = () => {
  zoomImageEvents($('.quickview-image .zoomController'), $('.quickview-image .mainImage'), $('.quickview-image #zoomContainer'), $('.quickview-image .zoom-close'));
}

const zoomMainImageD = () => {
  zoomImageEvents($('.zoomController'), $('.mainImage'), $('#zoomContainer'), $('.zoom-close'));
};

const zoomMainImageMT = () => {
  // $('div.mainProductImage').addClass('pinch-zoom');
  // $('div.pinch-zoom').each(function() {
  //     new RTP.PinchZoom($(this), {});
  // });
  // $('div.qv-pinch-zoom').each(function() {
  //     new RTP.PinchZoom($(this), {});
  // });
};

const zoomQVImageMT = (mainImgTString, qvImgChange, paramJSONCatentryId, paramJSONcolor) => {
  $('.quickview-image img.mainImage').on('load', function() {
    let pinchZoomContent = `
      <div class="mainProductImage qv-pinch-zoom">
          ${mainImgTString}
      </div>
      `;
    // document.getElementById("containerPinchZoom").innerHTML = pinchZoomContent;
    $('#containerPinchZoom').append(pinchZoomContent);
    var cpzHeight = $('#containerPinchZoom').height();
    $('#containerPinchZoom').css('min-height', cpzHeight);
    $('div.qv-pinch-zoom').each(function() {
      new RTP.PinchZoom($(this), {});
    });
    setTimeout(function() {
      $(window).trigger('resize');
    }, 100);

    if (typeof qvImgChange == 'function' && $('.oss-modal').length > 0) qvImgChange(paramJSONCatentryId, $('.oss-modal').length > 0, paramJSONcolor);
  });
  $(".modal .alt-image-list-container ul li img").click(function(e) {
    e.stopPropagation();
    var mainImage = $(this).parents('.modal-content').find('.mainImage')[0],
      newImage = $(this).data('fullimage'),
      selectedMainImage = $(this).data('fullimage').split('__')[0];
    $('.modal-quickview .color-select-group select, .modal-quickview .color-select select').each(function() {
      var foundColor = $(this).find('option[data-fullimage="' + selectedMainImage + '"]').val();
      if (foundColor) $(this).val(foundColor).trigger('change');
    });
    replaceImage($(mainImage), newImage);
    let pinchZoomContent = `
        <div class="mainProductImage qv-pinch-zoom">
        </div>
        `;
    $('#containerPinchZoom').append(pinchZoomContent);
    $('.qv-pinch-zoom').append(mainImage);
    $('#containerPinchZoom .pinch-zoom-container:first-of-type').remove();

    $('div.qv-pinch-zoom').each(function() {
      new RTP.PinchZoom($(this), {});
    });
    setTimeout(function() {
      $(window).trigger('resize');
    }, 100);
  });
};


export {
  zoomMainImageD,
  zoomQVImageD,
  zoomQVImageMT
}
